module.exports = __webpack_public_path__ + "img/background2d.0a161f0e.png";